export default "__VITE_ASSET__rihAsenn__"